import React from 'react';
import PropTypes from 'prop-types';
import ScrollToPrevious from '@components/ScrollToPrevious';
import './style.scss';
import pronounce from '@media/jeongseok.mp3';

const MiscPage = (props, context) => {
  const {
    theme: { colorPrimary, colorHighlight, bgPrimary, textPrimary }
  } = context;

  const audio = new Audio(pronounce);

  return (
    <div className="misc-page" style={{ backgroundColor: bgPrimary }}>
      <style jsx="true">
        {`
          .misc-page .highlight {
            background-color: ${colorHighlight};
          }
          .misc-page a {
            color: ${colorPrimary};
          }
          .misc-page a:hover {
            background-color: ${colorHighlight};
          }
        `}
      </style>
      <div className="content-grid">
        <h1 style={{ color: colorPrimary }}>Miscellaneous</h1>
        <div className="misc-wrapper">
        <div className="misc-content" style={{ color: textPrimary }}>
            <ul>
              <li>
                <span className="highlight">손정석</span> is my name in <a href="https://en.wikipedia.org/wiki/Hangul">Hangul</a>. Son Jeongseok is the <a href="https://en.wikipedia.org/wiki/Revised_Romanization_of_Korean">romanization</a> of it.<br />
                <span className="highlight">How to pronounce?:</span> My given name has two syllables: 정-석 (Jeong-Seok). 정 (Jeong) is pronounced as the "jung" in "jungle", and 석 (Seok) sounds like "suck" but with a softer S sound, like "s-huck". Here is the <button onClick={() => audio.play()}><i className="fas fa-volume-up"></i> audio pronunciation</button>.<br />
                I also go by the name of <span className="highlight">Jason</span>, which sounds similiar to my initials "J. Son".
              </li>

              <li>
                I grew up in <a href="https://en.wikipedia.org/wiki/Jeju_Island">Jeju</a>, a beautiful island and popular tourist attraction in South Korea. I lived in <a href="https://en.wikipedia.org/wiki/Daejeon">Daejeon</a>, where <a href="https://en.wikipedia.org/wiki/Daedeok_Science_Town">the largest research cluster</a> in the nation is located, for college and then lived in <a href="https://en.wikipedia.org/wiki/Seoul">Seoul</a> for work. I also stayed in <a href="https://en.wikipedia.org/wiki/Champaign%E2%80%93Urbana_metropolitan_area">Champaign-Urbana, Illinois</a> in the USA for a year and <a href="https://en.wikipedia.org/wiki/Beijing">Beijing</a> in PRC for 8 months. Now I live in the <a href="https://en.wikipedia.org/wiki/San_Francisco_Bay_Area">San Francisco Bay Area, California</a> in the USA.
              </li>
            </ul>
          </div>
        </div>
      </div>
      <ScrollToPrevious pageSelector=".about-page" />
    </div>
  );
};

MiscPage.contextTypes = {
  theme: PropTypes.any
};

export default MiscPage;



// WEBPACK FOOTER //
// ./src/pages/MiscPage/MiscPage.js